import * as React from 'react';

import { Col, Form, Radio, Row, Space } from 'antd';
import { useAppDispatch, useAppSelector } from 'src/types/reduxHelpers';

import { InterviewComponent } from 'src/components/interviewComponents/types/interviewComponent';
import { nameof } from 'ts-simple-nameof';
import { setWagesAndBenefits } from 'src/store/modules/interviewModule';
import { useTranslation } from 'react-i18next';

interface WagesAndBenefitsProps {

}

interface WagesAndBenefitsFormValues {
    isSalaryAdequate : boolean;
    isBonusSatisfy : boolean | 'na';
    isHealthBenefitGood : boolean| 'na';
    isPensionPlanAdequate : boolean | 'na';
}

export const WagesAndBenefits: InterviewComponent<WagesAndBenefitsProps> = React.forwardRef((props, ref) => {
    const { t } = useTranslation();

    const dispatch = useAppDispatch();

    const [form] = Form.useForm<WagesAndBenefitsFormValues>();

    const wagesAndBenefits = useAppSelector((state) => state.interview.wagesAndBenefits);

    React.useImperativeHandle(ref, () => ({
        submit: async () => {
            try {
                await form.validateFields();

                form.submit();

                return true;
            } catch (err) {
                return false;
            }
        },
    }));

    return (
        <Row
            align="middle"
            justify="center"
            gutter={[30, 20]}
        >
            <Col
                span={24}
            >
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={(values) => {
                        console.table(values);

                        // We're storing 'agree'/'disagree'/'not applicable' values as:
                        // agree = true
                        // disagree = false
                        // not applicable = null
                        // but the form values have issues when defaulting to null.

                        // Lets make the 'not applicable' values 'na' and convert back and forth as needed
                        dispatch(setWagesAndBenefits({
                            isSalaryAdequate: values.isSalaryAdequate,
                            isBonusSatisfy: values.isBonusSatisfy === 'na'
                                ? null
                                : values.isBonusSatisfy,
                            isHealthBenefitGood: values.isHealthBenefitGood === 'na'
                                ? null
                                : values.isHealthBenefitGood,
                            isPensionPlanAdequate: values.isPensionPlanAdequate === 'na'
                                ? null
                                : values.isPensionPlanAdequate,
                        }));
                    }}
                >
                    {/* Question 8 */}
                    <Form.Item
                        label={t('Components.InterviewComponents.WagesAndBenefits.is_salary_adequate_label')}
                        name={nameof<WagesAndBenefitsFormValues>(x => x.isSalaryAdequate)}
                        rules={[{ required: true }]}
                        // Tan : refered back to jobDetail.tsx //
                        initialValue={wagesAndBenefits?.isSalaryAdequate}
                    >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={true}>
                                    {t('Common.agree')}
                                </Radio>
                                <Radio value={false}>
                                    {t('Common.disagree')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>

                    {/* Question 9 */}
                    <Form.Item
                        label={t('Components.InterviewComponents.WagesAndBenefits.is_bonus_satisfy_label')}
                        name={nameof<WagesAndBenefitsFormValues>(x => x.isBonusSatisfy)}
                        rules={[{ required: true }]}
                        // Tan : refered back to jobDetail.tsx //
                        initialValue={wagesAndBenefits?.isBonusSatisfy === null ? 'na' : wagesAndBenefits?.isBonusSatisfy}
                    >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={true}>
                                    {t('Common.agree')}
                                </Radio>
                                <Radio value={false}>
                                    {t('Common.disagree')}
                                </Radio>
                                <Radio value={'na'}>
                                    {t('Common.not_applicable')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>

                    {/* Question 10 */}
                    <Form.Item
                        label={t('Components.InterviewComponents.WagesAndBenefits.is_health_benefit_good_label')}
                        name={nameof<WagesAndBenefitsFormValues>(x => x.isHealthBenefitGood)}
                        rules={[{ required: true }]}
                        // Tan : refered back to jobDetail.tsx //
                        initialValue={wagesAndBenefits?.isHealthBenefitGood === null ? 'na' : wagesAndBenefits?.isHealthBenefitGood}
                    >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={true}>
                                    {t('Common.agree')}
                                </Radio>
                                <Radio value={false}>
                                    {t('Common.disagree')}
                                </Radio>
                                <Radio value={'na'}>
                                    {t('Common.not_applicable')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>

                    {/* Question 11 */}
                    <Form.Item
                        label={t('Components.InterviewComponents.WagesAndBenefits.is_pension_plan_adequate_label')}
                        name={nameof<WagesAndBenefitsFormValues>(x => x.isPensionPlanAdequate)}
                        rules={[{ required: true }]}
                        initialValue={wagesAndBenefits?.isPensionPlanAdequate === null ? 'na' : wagesAndBenefits?.isPensionPlanAdequate}
                    >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={true}>
                                    {t('Common.agree')}
                                </Radio>
                                <Radio value={false}>
                                    {t('Common.disagree')}
                                </Radio>
                                <Radio value={'na'}>
                                    {t('Common.not_applicable')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>
                </Form>
            </Col>
        </Row>
    );
});

WagesAndBenefits.displayName = 'WagesAndBenefits';